import Box from '@mui/material/Box'
import {
  DashboardStatusFilter,
  type DashboardStatusFilterOption,
} from '@/features/dashboard/components/DashboardStatusFilter'
import type {
  SensemakerListFilterState,
  SensemakerPackageFilter,
  SensemakerStatusFilter,
} from '../lib/sensemaker-list-filters'
import {
  SENSEMAKER_LIST_FILTER_GAP_PX,
  SENSEMAKER_LIST_FILTER_LABEL_VALUE_GAP_PX,
  SENSEMAKER_LIST_FILTER_WIDTH_PX,
} from '../lib/sensemaker-list-layout'

const STATUS_OPTIONS: readonly DashboardStatusFilterOption<SensemakerStatusFilter>[] = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'deactivated', label: 'Deactivated' },
  { value: 'expired', label: 'Expired' },
]

const PACKAGE_OPTIONS: readonly DashboardStatusFilterOption<SensemakerPackageFilter>[] = [
  { value: 'all', label: 'All' },
  { value: '01', label: 'Package 01' },
  { value: '02', label: 'Package 02' },
  { value: '03', label: 'Package 03' },
]

interface Props {
  filters: SensemakerListFilterState
  onFiltersChange: (next: SensemakerListFilterState) => void
}

/** Figma `1:1010` — status/package filter dropdowns (225×42, 20px gap). */
export function SensemakerListFilters({ filters, onFiltersChange }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: `${SENSEMAKER_LIST_FILTER_GAP_PX}px`,
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
      }}
    >
      <DashboardStatusFilter
        value={filters.status}
        onChange={(status) => onFiltersChange({ ...filters, status })}
        options={STATUS_OPTIONS}
        filterWidth={SENSEMAKER_LIST_FILTER_WIDTH_PX}
        labelPrefix="Filter by Status"
        labelValueGapPx={SENSEMAKER_LIST_FILTER_LABEL_VALUE_GAP_PX}
        testId="sensemaker-list-status-filter"
      />
      <DashboardStatusFilter
        value={filters.package}
        onChange={(packageTier) => onFiltersChange({ ...filters, package: packageTier })}
        options={PACKAGE_OPTIONS}
        filterWidth={SENSEMAKER_LIST_FILTER_WIDTH_PX}
        labelPrefix="Filter by Package"
        labelValueGapPx={SENSEMAKER_LIST_FILTER_LABEL_VALUE_GAP_PX}
        testId="sensemaker-list-package-filter"
      />
    </Box>
  )
}
